import { vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/inverted-shipedBL.svg'
import _imports_1 from '@/assets/shipd.svg'


const _withScopeId = n => (_pushScopeId("data-v-8960dcbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-bars icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-times icon inv",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 2,
  class: "nav-wrapper"
}
const _hoisted_6 = {
  key: 0,
  class: "cta"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["wrapper", { showNavbar: $setup.showNavbar == true }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["box", { navbarStyle: $setup.showNavbar == true }])
    }, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("img", {
            src: _imports_0,
            alt: "logotyp",
            class: _normalizeClass(["logotyp", { logotypHeight: $setup.scrollPosition > 50 && $setup.windowSize >= 995 }])
          }, null, 2), [
            [_vShow, $setup.showNavbar]
          ]),
          _withDirectives(_createElementVNode("img", {
            src: _imports_1,
            alt: "logotyp",
            class: _normalizeClass(["logotyp", { logotypHeight: $setup.scrollPosition > 50 && $setup.windowSize >= 995 }])
          }, null, 2), [
            [_vShow, !$setup.showNavbar]
          ])
        ]),
        _: 1
      }),
      (!$setup.showNavbar && $setup.windowSize < 995)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "icon-btn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.toggleNavbar && $setup.toggleNavbar(...args)))
          }, _hoisted_2))
        : _createCommentVNode("", true),
      ($setup.showNavbar && $setup.windowSize < 995)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "icon-btn",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.toggleNavbar && $setup.toggleNavbar(...args)))
          }, _hoisted_4))
        : _createCommentVNode("", true),
      ($setup.showNavbar || $setup.windowSize >= 995)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              class: "enterprise",
              to: "/learn-more"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Learn more")
              ]),
              _: 1
            }),
            ($setup.showNavbar || $setup.windowSize >= 995)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_ctx.$store.state.user == null)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        class: "login",
                        to: "/signin"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Sign in")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.$store.state.user !== null)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 1,
                        class: "register",
                        to: "/signup"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$store.state.user ? "My Account" : "Get Started"), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}